import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Link from "next/link";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Typography,
  Avatar,
  Box,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import logo from "../../assets/landing/Banner-logo.svg";
import Image from "next/image";
import style from "../../styles/SignIn.module.css";
import Swal from "sweetalert2";
import * as constants from "../../Components/constants";
import { useRouter } from "next/router";
import { useState } from "react";
import Registration from "../../Components/Registration/Registration";
import ForgetPass from "../../Components/ForgetPass";
import { NextSeo } from "next-seo";
import CircularProgress from "@mui/material/CircularProgress";
import LoginFooter from "../../Components/Shared/LoginFooter/LoginFooter";

const theme = createTheme();
const baseURL = constants.BASE_URL;

export default function Login() {
  const router = useRouter();

  //Toggole sign up and registation
  const [showResults, setShowResults] = React.useState(true);
  const [isLoading, setLoading] = React.useState(false);

  // states for login
  const [username, setUsername] = useState("");
  const [passForLogin, setPassForLogin] = useState("");

  //Forget Pass Modal
  const [showB, setShowB] = useState(false);
  const toggleShowB = () => setShowB(!showB);

  //Token Check Function

  React.useEffect(() => {
    if (localStorage.auth_token) {
      fetch(`${baseURL}/user/token-check`, {
        mode: "cors",
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: localStorage.getItem("auth_token"),
        }),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => console.log(error));
    } else {
    }
  });

  // Login function start
  const loginHeader = {
    mode: "cors",
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: username,
      password: passForLogin,
    }),
  };

  const [mailErr, setMailErr] = useState(false);
  const [passErr, setPassErr] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    fetch(`${baseURL}/user/signin`, loginHeader)
      .then((response) => response.json())
      .then((data) => {
        if (data?.data?.is_active) {
          window.localStorage.setItem("id", data.data.id);
          window.localStorage.setItem("first_name", data.data.first_name);
          window.localStorage.setItem("last_name", data.data.last_name);
          window.localStorage.setItem("email", data.data.email);
          window.localStorage.setItem("auth_token", data.data.token);
          setLoading(false);
          router.push(`/user/${localStorage.id}`);
        } else if (data.data.is_active === false) {
          setLoading(false);
          Swal.fire({
            title:
              "You haven't verified your email. Please verified your email first",
            icon: "warning",
            confirmButtonColor: "#ff0000",
            confirmButtonText: "Ok",
          });
          router.push("/user/verification");
        }
      })
      .catch((error) => {
        if (username === "") {
          setLoading(false);
          setMailErr(true);
        } else if (passForLogin === "") {
          setLoading(false);
          setPassErr(true);
        } else {
          setLoading(false);
          Swal.fire({
            title: `Please make sure all fields are filled in correctly`,
            icon: "warning",
            confirmButtonColor: "#ff0000",
            confirmButtonText: "Ok",
          });
        }
      });
    setMailErr(false);
    setPassErr(false);
  };
  // Login function end

  return (
    <ThemeProvider theme={theme}>
      <NextSeo
        title="Research Rider | Log In"
        description="Be connected with the worldwide research hub."
        canonical="https://www.researchrider.com/user/login"
        openGraph={{
          url: "https://www.researchrider.com/user/login",
          title: "Research Rider | Log In",
          description: "Be connected with the worldwide research hub.",
          siteName: "Research Rider",
        }}
      />

      <Grid
        container
        component="main"
        sx={{ height: "100vh" }}
        className={style.main_box}
      >
        <CssBaseline />
        <Grid
          item
          className={`${style.mobile_view} ${style.bg_color}`}
          xs={12}
          sm={6}
          md={8}
        >
          <Box
            xs="false"
            sx={{
              xs: false,
              my: 18,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div className={`${style.rr_logo}`}>
              <Image
                src={logo}
                layout="fill"
                alt="research rider logo"
                priority
              />
            </div>
            <span className="text-white fw-bold fs-2">
              Grow up Being a Researcher
            </span>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          {showResults ? (
            <Box
              className={`${style.signIn_box}`}
              sx={{
                my: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Avatar sx={{ bgcolor: "secondary.main" }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h4" variant="h6">
                Sign in
              </Typography>
            </Box>
          ) : (
            <Box
              className={`${style.signup_box}`}
              sx={{
                my: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Avatar sx={{ bgcolor: "secondary.main" }}>
                <HowToRegIcon />
              </Avatar>
              <Typography component="h4" variant="h6">
                Sign up
              </Typography>
            </Box>
          )}

          {showResults ? (
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{
                mx: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TextField
                error={mailErr ? true : false}
                margin="normal"
                required
                label="Email Address"
                className="w-100"
                onChange={(e) => setUsername(e.target.value)}
              />
              <TextField
                error={passErr ? true : false}
                margin="normal"
                required
                name="password"
                label="Password"
                type="password"
                id="password"
                className="w-100"
                onChange={(e) => setPassForLogin(e.target.value)}
              />

              <Box sx={{ my: 2, position: "relative", width: "100%" }}>
                <Button
                  fullWidth
                  variant="contained"
                  type="submit"
                  disabled={isLoading}
                >
                  sign in
                </Button>
                {isLoading && (
                  <CircularProgress
                    size={20}
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      marginTop: "-10px",
                      marginLeft: "-12px",
                    }}
                  />
                )}
              </Box>

              <Grid container sx={{ cursor: "pointer" }}>
                <Grid item xs>
                  <Typography
                    fontSize={14}
                    color="primary"
                    variant="caption"
                    onClick={toggleShowB}
                    noWrap
                  >
                    Forgot password?
                  </Typography>
                </Grid>
                <Grid item onClick={() => setShowResults(false)}>
                  <Typography variant="overline">
                    New to Research Rider?{" "}
                    <span className="text-primary fw-bold">Sign up</span>
                  </Typography>
                </Grid>
                <Typography variant="caption" sx={{ pt: 1.5 }}>
                  If you haven&apos;t verified you account please{" "}
                  <Link href="/user/verifymail">verify</Link> your account.
                </Typography>
              </Grid>
            </Box>
          ) : (
            <Box
              sx={{
                mx: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Registration />

              <Grid container sx={{ cursor: "pointer" }}>
                <Grid item onClick={() => setShowResults(true)}>
                  <Typography variant="overline">
                    Already on Research Rider?{" "}
                    <span className="text-primary fw-bold">Log in</span>
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          )}
          <LoginFooter />
        </Grid>
      </Grid>

      <>
        <ForgetPass
          toggleShowB={() => toggleShowB()}
          showB={showB}
          setShowB={setShowB}
        />
      </>
    </ThemeProvider>
  );
}
